"use strict";
module.exports = require('./en');



//////////////////
// WEBPACK FOOTER
// ../~/date-names/index.js
// module id = ../node_modules/date-names/index.js
// module chunks = 1